import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://api.bluedartexpress.ae/api/public',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;
